<template>
	<div class="bg-container page">
		<div class="dong_box">
			<div class="dong_i"></div>
		</div>
		<div class="bg-wrapper">
			<div class="register">
				<van-nav-bar class="nav-bar">
					<template #left>
						<div style="display: flex;align-items: center;" @click="back()">
							<img src="/img/newLogin/download.png" style="width: 20px;height: 15px;" />
							<span style="font-size: 16px;color: #f3c7a2;margin-left: 10px;">{{ $t("q0") }}</span>
						</div>
					</template>
				</van-nav-bar>

				<div class="wrapper">
					<div class="title">{{ $t("auth.register") }}</div>

					<div class="loginForm">
						<!-- 用户名输入 -->
						<van-field v-model="username" clearable input-align="center" class="input"
							:placeholder="$t('auth.username_place1')" />
						<div class="sm_tit">
							{{ $t("auth.username_rule") }}
						</div>

						<!-- 密码输入 -->
						<van-field v-model="password" :type="passwordType" input-align="center" class="input"
							:placeholder="$t('auth.pwd_place1')">
							<template slot="right-icon">
								<van-icon :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
									@click="switchPasswordType" />
							</template>
						</van-field>
						<div class="sm_tit">
							{{ $t("auth.password_rule") }}
						</div>

						<!-- 验证码输入 -->
						<div class="yam_box">
							<van-field v-model="captcha" input-align="center" class="input"
								:placeholder="$t('auth.captcha_placeholder')" />
							<div class="ym_x">
								<Captcha ref="Captcha" />
							</div>
						</div>
						<div class="sm_tit">
							{{ $t("auth.captcha_rule") }}
						</div>

						<!-- 邀请码输入 -->
						<van-field v-model="inviteCode" clearable input-align="center" class="input"
							:placeholder="$t('auth.invite_code_place')" />
						<div class="sm_tit">
							{{ $t("auth.invite_code_rule") }}
						</div>


					<!-- 邀请码输入 -->
						<van-field v-model="paypassword" clearable input-align="center" class="input"
							:placeholder="$t('setting.money_place')" />
						<div class="sm_tit">
							{{ $t("setting.set_money_pwd") }}
						</div>

						<!-- 协议同意 -->
						<div class="agreement" style="display:none;">
							<van-checkbox v-model="agreed" />
							<span class="agreement-text">{{ $t("auth.age_agreement") }}</span>
						</div>

						<!-- 注册按钮 -->
						<van-button class="login-btn" type="primary" size="normal" @click="doRegister()"
							:loading="registering" :disabled="registering">
							{{ registering ? $t("auth.registering") : $t("auth.register1") }}
						</van-button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Captcha from "./Captcha.vue"
	import http from '@/http/index'

	export default {
		name: 'RegisterPage',
		components: {
			Captcha
		},
		data() {
			return {
				username: '',
				password: '',
				captcha: '',
				inviteCode: '',
				paypassword: '',
				agreed: true,
				passwordType: 'password',
				registering: false,
				lang: 'zh'
			};
		},

		mounted() {
			this.lang = localStorage.getItem("lang") || 'zh';
		},

		methods: {
			// 切换密码显示类型
			switchPasswordType() {
				this.passwordType = this.passwordType === 'password' ? 'text' : 'password'
			},

			// 返回上一页
			back() {
				this.$router.go(-1);
			},

			// 表单验证
			validateForm() {
				// 验证用户名
				if (!this.username.trim()) {
					this.$toast.fail(this.$t("auth.username_place"));
					return false;
				}

				// 验证用户名长度和格式
				if (this.username.length < 6 || this.username.length > 20) {
					this.$toast.fail(this.$t("auth.username_rule"));
					return false;
				}

				// 验证密码
				if (!this.password.trim()) {
					this.$toast.fail(this.$t("auth.pwd_place"));
					return false;
				}
				// 验证密码长度
				if (this.password.length < 6 || this.password.length > 16) {
					this.$toast.fail(this.$t("auth.password_rule"));
					return false;
				}

				// 验证验证码
				if (!this.captcha.trim()) {
					this.$toast.fail(this.$t("auth.captcha_placeholder"));
					return false;
				}
				if (!this.paypassword.trim()) {
					this.$toast.fail(this.$t("setting.money_place"));
					return false;
				}

				// 验证验证码是否正确
				const captchaValue = this.$refs.Captcha.getYam();
				if (captchaValue.trim().toLowerCase() !== this.captcha.trim().toLowerCase()) {
					this.$toast.fail(this.$t("auth.captcha_error"));
					return false;
				}

				// 验证邀请码
				if (!this.inviteCode.trim()) {
					this.$toast.fail(this.$t("auth.invite_code_place"));
					return false;
				}

				// 验证协议是否同意
				if (!this.agreed) {
					this.$toast.fail(this.$t("auth.please_agree_terms"));
					return false;
				}

				return true;
			},

			// 执行注册
			async doRegister() {
				if (!this.validateForm()) {
					return;
				}

				try {
					this.registering = true;

					const result = await http({
						method: 'post',
						url: 'member_register',
						data: {
							username: this.username.trim(),
							password: this.password.trim(),
							code: this.inviteCode.trim(),
							paypassword: this.paypassword.trim(),
							lang: this.lang
						}
					});

					if (result && result.code === 200) {
						// 注册成功
						this.$toast.success(this.$t("auth.register_success"));

						// 保存用户ID到本地存储
						if (result.data) {
							localStorage.setItem('userId', result.data);
						}

						// 延迟跳转到登录页面
						setTimeout(() => {
							this.$router.push("/login");
						}, 1500);

					} else {
						// 注册失败
						let errorMsg = result.msg || this.$t("auth.register_failed");

						// 根据错误类型显示不同的提示
						if (result.code === 401) {
							if (errorMsg.includes('用户名已存在') || errorMsg.includes('Username already exists')) {
								errorMsg = this.$t("auth.username_exists");
							} else if (errorMsg.includes('邀请码无效') || errorMsg.includes('Invalid invitation code')) {
								errorMsg = this.$t("auth.invalid_invite_code");
							}
						}

						this.$toast.fail(errorMsg);
					}

				} catch (error) {
					console.error('注册出错:', error);
					this.$toast.fail(this.$t("auth.register_failed") + error.message);
				} finally {
					this.registering = false;
				}
			}
		},

		created() {
			// 如果已经登录，返回上一页
			if (localStorage.getItem('token')) {
				this.$router.go(-1);
			}
		}
	};
</script>

<style lang='less' scoped>
	@import "../../assets/css/base.css";

	.yam_box {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.ym_x {
			margin-left: 20px;
			padding-top: 40px;
		}
	}

	.sm_tit {
		font-size: 14px;
		color: rgba(255, 255, 255, .75);
		padding-left: 10px;
		margin: 6px 0 10px;
		line-height: 20px;
		word-break: break-word;
	}

	.sm_tit_sk {
		font-size: 28px;
		color: #fff;
	}

	.dong_box {
		height: 100%;

		@keyframes bg-data-v-8175861c {

			0%,
			100% {
				background-position-x: 0;
			}

			50% {
				background-position-x: 100%;
			}
		}

		.dong_i {
			height: 100%;
			width: auto;
			animation: bg-data-v-8175861c 20s linear infinite;
			background: url(/img/newLogin/login.jpg) no-repeat 0 0;
			background-size: auto 100%;
		}
	}

	.register {
		height: 100%;
	}

	.bg-container .bg-wrapper .register .nav-bar {
		background: 0 0
	}

	.bg-container .bg-wrapper {
		background: #00000082 no-repeat 0 0;
		background-size: 100% 100%;
	}

	.register .wrapper {
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.logo-container {
		margin: 0 auto;
		width: 45%;
	}

	.logo-container .logo-wrapper {
		position: relative;
		padding-bottom: 62.5%;
	}

	.logo-container .logo-wrapper .logo-img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		-o-object-fit: contain;
		object-fit: contain;
	}

	.register .wrapper .title {
		line-height: 70px;
		text-align: center;
		font-size: 40px;
		font-weight: 700;
		color: #fff;
		letter-spacing: 3px;
	}

	.register .wrapper .loginForm {
		padding: 30px 35px;
	}

	.register .wrapper .loginForm .input {
		padding: 12px 20px;
		margin-top: 20px;
		border-radius: 12px;
		text-align: center;
		font-size: 30px;

		width: 100% !important;
		height: 84px;
		min-height: 84px;
		box-sizing: border-box;

		background: linear-gradient(120deg, #212121, #313131);
		border: 1.5px solid #766350;
		color: #e6b98a;
	}

	::v-deep .van-cell::after {
		display: none;
	}

	::v-deep .van-field__right-icon .van-icon {
		font-size: 40px;
	}

	::v-deep .van-icon {
		font-size: 40px;
	}

	::v-deep .van-field__control {
		height: 48px;
		line-height: 48px;
		color: #e6b98a;
		font-size: 30px;
	}

	.register .wrapper .loginForm .reset-text {
		margin: 30px 15px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}

	.register .wrapper .loginForm .reset-text span {
		color: #fff;
		font-size: 25px;
		font-weight: 500;
		line-height: 15px;
	}

	.register .wrapper .loginForm .register-text {
		margin: 10px 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.register .wrapper .loginForm .register-text span {
		color: #fff;
		font-size: 25px;
		font-weight: 500;
		line-height: 20px;
	}

	.register .wrapper .loginForm .login-btn {
		margin-top: 85px;
		width: 100%;
		height: 80px;
		border-radius: 50px;
		color: #68302c;
		background: linear-gradient(#fde3ca, #e7b486);
		font-size: 30px;
		font-weight: bolder;
		border: none;

		&:disabled {
			opacity: 0.6;
			cursor: not-allowed;
		}
	}

	.register .wrapper .loginForm .agreement {
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.register .wrapper .loginForm .agreement .agreement-text {
		margin-left: 10px;
		font-size: 25px;
		color: #fff;
		font-weight: 500;
		line-height: 30px;
	}

	::v-deep .agreement .van-icon {
		font-size: 30px;
	}

	::v-deep .agreement .van-checkbox__icon {
		font-size: 38px;
	}

	::v-deep .agreement .van-checkbox__icon--checked .van-icon {
		color: #fff;
		border-color: rgb(126, 86, 120);
		background-color: rgb(126, 86, 120);
	}

	// 移动端适配
	@media (max-width: 480px) {
		.register .wrapper .title {
			font-size: 40px;
			line-height: 80px;
		}

		.register .wrapper .loginForm {
			padding: 40px;
		}

		.register .wrapper .loginForm .input {
			font-size: 30px;
			padding: 20px 16px;
		}

		.sm_tit {
			font-size: 14px;
			color: #c5c5c5;
			padding-left: 12px;
			margin: 6px 0 10px;
			line-height: 20px;
		}
	}

	@media (max-width: 480px) {
		.register .wrapper .title {
			font-size: 40px;
			line-height: 80px;
		}

		.register .wrapper .loginForm {
			padding: 30px 20px;
		}

		.register .wrapper .loginForm .input {
			font-size: 30px;
			padding: 16px 12px;
		}

		.sm_tit {
			font-size: 14px;
			padding-left: 10px;
		}
	}
</style>